"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Colors = void 0;
var Colors = {
    spicyRed: "#e84746",
    mustaYellow: "#f2bd42",
    nightBlack: "#030726",
    coal: "#333333",
    nickel: "#666666",
    moon: "#999999",
    silver: "#cccccc",
    smoke: "#f2f2f2",
    snow: "#ffffff",
    failure: "#e74c3c",
    warning: "#f1c40f",
    success: "#2ecc71",
    info: "#379cf9",
    transparentize: function (color, amount) {
        return "" + Colors[color] + Math.round((1 - amount) * 255).toString(16);
    },
    graph: {
        red1: "#dd5571",
        yellow1: "#f9d277",
        green1: "#61d2a4",
        blue: "#3d89ae",
        grey: "#183b4b",
        black: "#02040e",
        red2: "#791633",
        yellow2: "#da9835",
        purple1: "#543081",
        beige1: "#fbe6d6",
        green2: "#4f8d8b",
        red3: "#e05d58",
        beige2: "#d8bfab",
        purple2: "#7e7f9a",
        red4: "#bc4749",
        green3: "#b8e0d2",
        beige3: "#d99a7a",
        pink1: "#fadcdb",
        pink2: "#cf848f",
        purple3: "#9a6a6a",
        getColorByIndex: function (index) {
            var _a;
            var colorKeys = Object.keys(Colors.graph)
                .filter(function (k) { return !["getColorByIndex"].includes(k); });
            return (_a = Colors.graph[colorKeys[index]]) !== null && _a !== void 0 ? _a : null;
        }
    }
};
exports.Colors = Colors;
//# sourceMappingURL=Colors.js.map